@if (!usersWithAccess?.length && isLoaded) {
    <div class="panel-list-item">
        {{ nonUsersText }}
    </div>
}

@for (user of usersWithAccess; track user.id) {
    <div class="d-flex align-items-center panel-list-item">
        <sb-user-avatar
            class="user-avatar-sm pointer"
            [user]="user"
            [withRoleTooltip]="true"
            (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: user })"
            [size]="'small'">
        </sb-user-avatar>
        <div class="truncate">
            <div class="truncate">
                {{ user.name }}
            </div>
            <div class="item-email truncate text-light">
                {{ user.email }}
            </div>
        </div>
    </div>
}

<button (click)="openGiveAccessModal()" class="btn btn-icon">
    <sb-inline-svg
        class="icon icon-sm"
        aria-label="My icon"
        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Outlined plus icon.svg'"></sb-inline-svg>
</button>

@if (!isLoaded) {
    <sb-loader></sb-loader>
}

<div class="clearfix"></div>
